module.exports = __webpack_public_path__ + "static/media/desktop.ab5b1402.PNG";